import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Span,
  Label,
  Select,
  InnerPanel
} from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

import { getMcpTools } from '../../../../../../api/mcp';

const InvokeMcpSkillContent = ({ content, onChange }) => {
  const [tools, setTools] = useState([]);

  useEffect(() => {
    getMcpTools().then(({ data }) => setTools(data.tools ?? []));
  }, []);

  const selectedTool = tools.find(t => t.name === content.skill_name) ?? null;

  const skillOptions = tools.map(t => ({ value: t.name, label: t.name }));

  const fields = selectedTool
    ? Object.entries(selectedTool.inputSchema?.properties ?? {}).map(
        ([key, def]) => ({
          key,
          label: def.description ?? key,
          required: (selectedTool.inputSchema?.required ?? []).includes(key)
        })
      )
    : [];

  const handleSkillChange = ({ value }) => {
    onChange({ skill_name: value, arguments: {} });
  };

  const handleArgumentChange = key => value => {
    onChange({
      ...content,
      arguments: { ...(content.arguments ?? {}), [key]: value }
    });
  };

  return (
    <Flex col fat xSpace>
      <Flex center fat="true" xSpace mb>
        <Span noWrap>using skill</Span>
        <Flex col fat>
          <Select
            aria-label="MCP skill"
            placeholder="Select a skill..."
            options={skillOptions}
            value={
              content.skill_name
                ? { value: content.skill_name, label: content.skill_name }
                : null
            }
            onChange={handleSkillChange}
          />
        </Flex>
      </Flex>

      {selectedTool?.description && (
       <Label>
        <Span light>
          {selectedTool.description}
        </Span>
       </Label>
      )}

      {selectedTool && (
        <InnerPanel>
          {fields.length === 0 && (
            <Span light mb>No arguments required.</Span>
          )}

          {fields.map((field, index) => (
            <Flex key={field.key} col fat mb={index < fields.length - 1}>
              <Label>
                {field.label}
              </Label>
              <TemplatingTextInput
                aria-label={field.label}
                placeholder={field.key}
                value={(content.arguments ?? {})[field.key] ?? ''}
                onChange={handleArgumentChange(field.key)}
              />
            </Flex>
          ))}
        </InnerPanel>
      )}
    </Flex>
  );
};

InvokeMcpSkillContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    skill_name: PropTypes.string,
    arguments: PropTypes.object
  }).isRequired
};

export default InvokeMcpSkillContent;
